<template>
    <div class="mainbody modulewrap">
        <ffbanner :infodata="demandinfo"></ffbanner>
        <div class="demandoptionwrap" v-if="isload">
            <div class="demandoption realwrap">
                <div class="doct">
                    <dl>
                        <dd><a href="#" :class="{'cs':!myoption.ct}" @click="optionsupdate1(0)">{{$common.dicword('all')}}</a></dd>
                        <dd> <a href="#" :class="{'cs':(myoption.ct==1)}" @click="optionsupdate1(1)">{{$common.dicword('openclass')}}</a></dd>
                        <dd><a href="#" :class="{'cs':(myoption.ct==2)}" @click="optionsupdate1(2)">VIP</a></dd>
                    </dl>
                </div>
                <div class="dosp"></div>
                <div class="dock">
                    <dl>
                        <dd>
                            <a href="#" @click="memopup(0)" :class="{'cs':!myoption.ck}">
                                <img src="/images/courseallicon.png" />
                                <span>{{$common.dicword('all')}}</span>
                            </a>
                        </dd>
                        <dd v-for="item in cataloglist" :key="item.id">
                            <a href="#" :class="{'cs':(myoption.ck==item.id)}" @click="memopup(item.id)">
                                <img :src="item.icon" />
                                <span>{{$common.langinfo(item.title,item.title_en)}}</span>
                            </a>
                        </dd>
                    </dl>

                </div>

            </div>
        </div>
        <div class="demandmain" v-if="isload">
            <div class="demandsearch realwrap">
                <el-input :placeholder="$common.dicword('keyword')" v-model="myoption.kw" @change="optionsupdate" class="optioninput"><a href="#" slot="append" @click="optionsupdate">{{$common.dicword('search')}}</a></el-input>
            </div>
            <div class="demandwrap realwrap" v-if="isload">
                <div class="demandlist" v-if="$common.basic.isarrayexist(infolist)">
                    <dl class="demanditem demanditemborder" v-for="item in infolist" :key="item.id" @click="gocourse(item.id)">
                        <dt><img :src="item.cover" /></dt>
                        <dd>{{$common.langinfo(item.title,item.title_en)}}</dd>
                    </dl>
                    <dl class="demanditem"></dl>
                    <dl class="demanditem"></dl>
                </div>

                <div class="norecord" v-else>{{$common.dicword('norecord')}}</div>

                <div class="ffpage">
                    <el-pagination v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata" :small="$store.getters.issmall">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'demand',
        data() {
            return {
                isload: false,
                res: {},
                demandinfo: {},
                cataloglist: [],
                infolist: [],
                myoption: { 'kw': '', 'ct': 0, 'ck': 0 }
            };
        },
        methods: {
            initdata: function () {
                let jsondata = { 'postdata': { 'act': 'tea_demand' }, 'msg': '' };
                this.$common.post(jsondata, res => {
                    this.demandinfo = res.infodata;
                    this.cataloglist = res.infodatacatalog;

                    this.getdata();
                });
            },
            getdata: function () {

                let jsondata = {
                    'postdata': { 'act': 'tea_demand_list', 'cpage': this.res.cpage, 'data': this.myoption },
                };
                this.$common.post(jsondata, res => {
                    this.isload = true;
                    this.res = res;
                    this.infolist = res.infodata;
                });
            },
            optionsupdate: function () {
                this.res.cpage = 1;
                this.getdata();
            },
            optionsupdate1: function (v) {
                this.myoption.ct = this.myoption.ct == v ? 0 : v;
                this.optionsupdate();
            },
            memopup: function (v) {
                this.myoption.ck = this.myoption.ck == v ? 0 : v;
                this.optionsupdate();
            },
            gocourse: function (v) {
                this.$router.push('/course/' + v);
            }
        },
        mounted() {
            this.initdata();
        }
    }
</script>
